/**
 * Premium tier utilities.
 * Tiers in config are ordered from cheapest to most expensive.
 * Each tier includes all privileges of the previous tiers.
 */

/**
 * Returns true if currentTier meets or exceeds requiredTier in the tierOrder.
 * @param {string} currentTier - Player's current tier (or '' for free)
 * @param {string} requiredTier - Required tier for the feature
 * @param {string[]} tierOrder - Tier names ordered from cheapest to most expensive
 */
export function meetsTier(currentTier, requiredTier, tierOrder) {
  if (!requiredTier) return true;
  if (!currentTier) return false;
  const current = tierIndex(currentTier, tierOrder);
  const required = tierIndex(requiredTier, tierOrder);
  if (current < 0 || required < 0) return false;
  return current >= required;
}

/**
 * Returns the higher of two tier names according to tierOrder.
 */
export function pickBestTier(a, b, tierOrder) {
  if (!a) return b || '';
  if (!b) return a || '';
  const ia = tierIndex(a, tierOrder);
  const ib = tierIndex(b, tierOrder);
  if (ia < 0 && ib < 0) return a;
  if (ia < 0) return b;
  if (ib < 0) return a;
  return ib > ia ? b : a;
}

function tierIndex(tier, tierOrder) {
  if (!tier || !tierOrder) return -1;
  for (let i = 0; i < tierOrder.length; i++) {
    if (tierOrder[i].toLowerCase() === tier.toLowerCase()) return i;
  }
  return -1;
}
